import { Button } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { onOk, onSubmit } from '../../actions/shipmentAction.js';
import lang from './../../languages/en';
import { detectAdBlocker, handlePrintPreview } from './../../services/helper';
import { alertError } from './../../services/dialog';
import { printTest } from './../../utils/shipment';
import './styles.css';
import handlePermission from './../../containers/app/handlePermission';
import hanldeException from './../../services/handleException';
import { permissions } from '../../constants/index.js';

class TestPrinter extends Component {
    handlePrintTest = () => {
        this.props.handleLoading(true)
        let printer_paper = this.props.printer ? this.props.printer.PaperSize : 3
        printTest(printer_paper).then(res => {
            if (res.data) {
                this.props.handleLoading(false)
                handlePrintPreview(res.data)
            }
        }).catch(err => {
            hanldeException(err);
        })
    }

    onClick = () => {
        if (detectAdBlocker()) return;

        if (this.props.printer.PaperSize) {
            this.props.onOk('printed')
            this.handlePrintTest()
        } else {
            alertError(lang.setting_print)
        }
    }

    render() {
        return (
            <div className="print-preview-action">
                <Button
                    className="ant-btn-primary print-test-page"
                    size={'small'}
                    onClick={this.onClick}
                    disabled={this.props.loading || !handlePermission(permissions.PrinterSavePrinterSetting)}
                >
                    Print Test Page
                </Button>
            </div>
        )
    }
}
const mapStateToProps = state => {
    return {
        printer: state.settingPrinterReducer.printer,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        onOk: payload => {
            dispatch(onOk(payload))
        },
        onSubmit: payload => {
            dispatch(onSubmit(payload))
        },
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TestPrinter)



// WEBPACK FOOTER //
// ./src/components/test-printer/index.js